import React, { useContext, useState } from "react";
import { t } from "i18next";
import to from "await-to-js";

import { Modal } from "../../../../../components/Modal/Modal";
import { ModalsContext } from "../../../../../context/modals.context";
import { DatePicker } from "../../../../../components/DatePicker/DatePicker";
import { DATE_FORMAT } from "../../../../../core/constants";
import { ministryService } from "../../../../../modules/ministry/ministry.service";
import { toastService } from "../../../../../utils/toast.service";
import { Dayjs } from "dayjs";

interface IDestroyRecordsModalProps {
  refetch: () => void;
}

export const DestroyRecordsModal: React.FC<IDestroyRecordsModalProps> = ({
  refetch,
}) => {
  const { isModalVisible, clearModals, setError, modals } =
    useContext(ModalsContext);
  const [datum, setDatum] = useState<Dayjs | null>(null);

  const checkboxes = modals.data;

  const postMfMarkcieVraceneInsertUnistenje = async () => {
    const [err, res] = await to(
      ministryService.postMfMarkcieVraceneInsertUnistenje({
        ids: checkboxes,
        datumUnistavanja: datum,
      })
    );
    if (err || !res.success) return setError(res?.errorMessage);
    toastService.success("TOAST.UNISTENJE");
    refetch();
    clearModals();
    setDatum(null);
  };

  const handleClose = () => {
    clearModals();
    setDatum(null);
  };

  return (
    <Modal
      name="destroy-records-modal"
      onCancel={handleClose}
      width={300}
      destroyOnClose
      onOk={postMfMarkcieVraceneInsertUnistenje}
      title={t("EVIDENCIJA_MARKICA.UNOS_DATUMA_UNISTENJA")}
      okText={t("SETTINGS_COMPANY.SACUVAJ")}
      cancelButtonProps={{ style: { display: "none" } }}
      open={isModalVisible("unistiEvidencijuModal")}
    >
      <DatePicker
        placeholder={t("EVIDENCIJA_MARKICA.UNESI_DATUM_UNISTENJA")}
        name="datum-unistenja"
        onChange={(value) => setDatum(value)}
        className="mt-10"
        allowClear
        showToday={false}
        format={DATE_FORMAT}
      />
    </Modal>
  );
};
